
export const styles = ["Formal", "Casual", "Humorous"];
export const tones = ["Persuasive", "Informative", "Friendly"];
export const lengths = ["Short", "Medium", "Detailed"];
